import { FetchAPI } from '@iyunbao/fetch';
import { tools } from '@iyunbao/utils';

import {
  FetchProps,
} from './type';
import { parseAPIResult } from './tools';

export interface FetchResultProps {
  // 微服务{ code: number, result: any, message: string }
  // 老服务{ result: string, content: any }
  code?: number | string;
  message?: string;
  errorMsg?: string;
  result?: any;
  content?: any;
}

const fetch: any = new FetchAPI();

// 开启替换域名
fetch.setOptions({ replaceHostUrl: true });

/**
 * 接口获取数据
 * @param  {object}   option    接口参数
 * @param addUrlParams true     带上URL上的参数
 * @config {string}   url       链接
 * @config {string}   method    请求类型
 * @config {string}   data      请求参数
 * @config {boolean}  isLoading 请求状态
 */
fetch.fetchResult = (option: FetchProps, addUrlParams = true) => {
  return new Promise((resolve, reject) => {
    option = {
      url: '',
      method: 'get',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
      data: {},
      isLoading: false,
      ...option,
    };

    const allParams = addUrlParams ? tools.urlAllParams() : {};

    // 链接参数
    if (option && allParams && Object.keys(allParams).length) {
      option.data = {
        ...allParams,
        ...option.data,
      };
    }

    fetch
      .fetch(option)
      .then((data: FetchResultProps) => {
        const result: FetchResultProps = parseAPIResult(data);

        if (result && result.code === 0) {
          // 当层级只有一层的时候 给出全部的参数
          resolve(result);
        } else {
          reject(result.message || result.errorMsg || '请求异常');
        }
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export default fetch;
